/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Tea_PurchasesInputs */

const vi_nav_tea_purchases = /** @type {(inputs: Nav_Tea_PurchasesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mua chè từ hộ`)
};

/**

* @param {Nav_Tea_PurchasesInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const nav_tea_purchases = /** @type {((inputs?: Nav_Tea_PurchasesInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Tea_PurchasesInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_nav_tea_purchases(inputs)
});